import Vue from 'vue'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'
import { Trans } from './plugins/Translation'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(VueRouter);

const Router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL ,
  beforeEnter: Trans.routeMiddleware,
  routes : [
    { 
      path: '*', 
      redirect: '/en' // @todo : detect if navigator language is part of the "supported languages" and redirect as needed
    }, 
    {
      path: '/:lang',
      name: 'home',
      component: () => import('./views/Home3.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/home-1',
      name: 'home1',
      component: () => import('./views/Home.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/home-2',
      name: 'home2',
      component: () => import('./views/Home2.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/home-3',
      name: 'home3',
      component: () => import('./views/Home3.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/home-4',
      name: 'home4',
      component: () => import('./views/Home3.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/home-5',
      name: 'home5',
      component: () => import('./views/Home3.vue') , 
      children : [  
      ]
    }, 
    {
      path: '/:lang/about',
      name: 'about',
      component: () => import('./views/AboutIarc.vue') , 
      meta: { bodyClass : '' , breadcrumb: [ { name: 'about' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods',
      name: 'data-sources-methods',
      component: () => import('./views/DataMethodsIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-by-country-detailed-1',
      name: 'data-sources-methods-by-country-detailed',
      component: () => import('./views/DataMethodsDetailedIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods_detailed' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-by-country-detailed-2',
      name: 'data-sources-methods-by-country-detailed-2',
      component: () => import('./views/DataMethodsDetailedIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods_detailed-2' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-by-country-detailed-3',
      name: 'data-sources-methods-by-country-detailed-3',
      component: () => import('./views/DataMethodsDetailedIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods_detailed-3' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-by-country-detailed-4',
      name: 'data-sources-methods-by-country-detailed-4',
      component: () => import('./views/DataMethodsDetailedIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods_detailed-4' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-by-country-detailed-5',
      name: 'data-sources-methods-by-country-detailed-5',
      component: () => import('./views/DataMethodsDetailedIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods_detailed-5' } ] }
    }, 
    {
      path: '/:lang/data-sources-methods-2',
      name: 'data-sources-methods-2',
      component: () => import('./views/DataMethodsIarc.vue') , 
      meta: { breadcrumb: [ { name: 'data_methods' } ] }
    }, 
    {
      path: '/:lang/fact-sheets-populations',
      name: 'population-fact-sheets',
      component: () => import('./views/Factsheets.vue') , 
      meta: { breadcrumb: [ { name: 'factsheets' } ] }
    }, 
    {
      path: '/:lang/fact-sheets-cancers',
      name: 'cancer-fact-sheets',
      component: () => import('./views/Factsheets.vue') , 
      meta: { breadcrumb: [ { name: 'factsheets' } ] }
    }, 
    {
      path: '/:lang/fact-sheet-population/:population',
      name: 'fact-sheet-population',
      component: () => import('./views/FactsheetPdfPop.vue') , 
      meta: { breadcrumb: [ { name: 'factsheets' } ] }
    }, 
    {
      path: '/:lang/fact-sheet-cancer/:cancer',
      name: 'fact-sheet-cancer',
      component: () => import('./views/FactsheetPdfCancer.vue') , 
      meta: { breadcrumb: [ { name: 'factsheets' } ] }
    }, 
    {
      path: '/:lang/fact-sheets-populations',
      name: 'fact-sheets-populations',
      component: () => import('./views/FactsheetsPopulation.vue') , 
      meta: { breadcrumb: [ { name: 'factsheets_populations' } ] }
    }, 
    {
      path: '/:lang/fact-sheets-cancers',
      name: 'fact-sheets-cancers',
      component: () => import('./views/FactsheetsCancer.vue') ,
      meta: { breadcrumb: [ { name: 'factsheets_cancers' } ] } 
    }, 
    {
      path: '/:lang/dataviz',
      name: 'dataviz',
      component: () => import('./views/DatavizIarc.vue') , 
      meta: { breadcrumb: [ { name: 'dataviz' } ] } 
    }, 
    {
      path: '/:lang/help',
      name: 'help',
      component: () => import('./views/Help.vue') , 
    }, 
    {
      path: '/:lang/dataviz/population_pyramid',
      name: 'population_pyramid',
      component: () => import('./views/Dataviz/PopulationPyramid.vue')
    }, 
    {
      path: '/:lang/dataviz/bars',
      name: 'bars',
      component: () => import('./views/Dataviz/Bars.vue') , 
    },
    {
      path: '/:lang/dataviz/bars-compare-populations',
      name: 'bars-compare-populations',
      component: () => import('./views/Dataviz/Bars.vue') , 
    },
    {
      path: '/:lang/dataviz/pie',
      name: 'pie',
      component: () => import('./views/Dataviz/Pie.vue') , 
    }, 
    {
      path: '/:lang/dataviz/donut',
      name: 'donut',
      component: () => import('./views/Dataviz/Pie.vue') , 
    }, 
    {
      path: '/:lang/dataviz/tables',
      name: 'tables',
      component: () => import('./views/Dataviz/Tables.vue') , 
    }, 
    {
      path: '/:lang/dataviz/maps-heatmap',
      name: 'maps-heatmap',
      component: () => import('./views/Dataviz/Maps.vue') , 
    }, 
    {
      path: '/:lang/dataviz/maps-most-common-sites',
      name: 'maps-most-common-sites',
      component: () => import('./views/Dataviz/Maps.vue') , 
    }, 
    {
      path: '/:lang/dataviz/maps-ranking',
      name: 'maps-ranking',
      component: () => import('./views/Dataviz/Maps.vue') , 
    }, 
    {
      path: '/:lang/dataviz/globe',
      name: 'globe',
      component: () => import('./views/Dataviz/Maps.vue') , 
    }, 
    {
      path: '/:lang/dataviz/scatter-plot',
      name: 'scatter-plot',
      component: () => import('./views/Dataviz/Plots.vue') , 
    },
    {
      path: '/:lang/dataviz/strip-chart',
      name: 'strip-chart',
      component: () => import('./views/Dataviz/Plots.vue') , 
    },
    // prevalence
    {
      path: '/:lang/dataviz/bars-prevalence',
      name: 'bars-prevalence',
      component: () => import('./views/Dataviz/BarsPrevalence.vue') , 
    },
    {
      path: '/:lang/dataviz/bars-prevalence-compare-populations',
      name: 'bars-prevalence-compare-populations',
      component: () => import('./views/Dataviz/BarsPrevalence.vue') , 
    },
    {
      path: '/:lang/dataviz/pie-prevalence',
      name: 'pie-prevalence',
      component: () => import('./views/Dataviz/Pie.vue') , 
    }, 
    {
      path: '/:lang/dataviz/maps-prevalence',
      name: 'maps-prevalence',
      component: () => import('./views/Dataviz/Maps.vue') , 
    }, 
    {
      path: '/:lang/dataviz/tables-prevalence',
      name: 'tables-prevalence',
      component: () => import('./views/Dataviz/Tables.vue') , 
    }, 
    {
      path: '/:lang/dataviz/treemap',
      name: 'treemap',
      component: () => import('./views/Dataviz/Treemap.vue') , 
    },
    { 
      path: '/:lang/hello', 
      name: 'hello',
      component: () => import('@/csu-vue-components/test/Hello.vue')
    },
    { 
      path: '/:lang/table-svg', 
      name: 'table-svg',
      component: () => import('@/csu-vue-components/visualizations/TableSvg.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // `to` and `from` are both route objects
    // console.info("scrollBehavior",to,from,savedPosition)
    if (to.hash) {
      return { selector: to.hash }
    }
    else
      return { x: 0, y: 0 }
  }
})

Router.afterEach((to,from) => {
  /*let routing = to.path.split('/');
  delete routing[0] ; delete routing[1] ; 
  routing.filter(()=>{ return true })
  */
  if ( to.name != 'home')
  {
    // console.log("change router",to.name,
    setTimeout(() => {
      $('.header-menu-links .menu-item:first-child a').removeClass('router-link-active') ;
    }, 250 )   
  }
  //document.querySelector('html').className = routing.join(' ').trim(); 
  
}); 

/*Vue.use(VueAnalytics, {
  id: 'UA-120005283-5',
  Router
})*/

export default Router ; 